import type { PosStockSalePolicy } from '../domain/posTypes';
import {
  getEffectiveStockSalePolicy as getEffectiveStockSalePolicyCore,
  resolveEffectiveStockSalePolicy,
} from '../../inventory/public-api';

/** Política de venta sin stock y UI de cantidades en POS solo con capability `inventory`. */
export function resolvePosStockSalePolicy(
  branchPolicy: PosStockSalePolicy,
  inventoryCapabilityEnabled: boolean,
): PosStockSalePolicy {
  return resolveEffectiveStockSalePolicy(branchPolicy, inventoryCapabilityEnabled);
}

export function getEffectiveStockSalePolicy(
  branchId: string | null | undefined,
): PosStockSalePolicy {
  return getEffectiveStockSalePolicyCore(branchId);
}
